/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
import api from '../../services/service_item'
// import apiCenter from '../../services/service_undefined'
import apiV from '../../services/service_vendor'
import moment from 'moment'
export default {
  data () {
    return {
      start_date: moment(new Date()),
      end_date: moment(new Date()),
      title: 'จัดการข้อมูลลูกหนี้',
      search: '',
      currentPage: 1,
      items_perpage: 1000,
      money_type: 1,
      modal_active: false,
      modal_data: {
        'item_code': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'price': 0,
        'qty': 0,
        'avg_cost': 0,
        'lot_qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'discount_word': '',
        'discount_amount': 0,
        'amount': 0,
        'stock_type': 0,
        'rate1': 1,
        'rate2': 1,
        'is_cancel': 0,
        'line_number': 0,
        'isVat': 1
      },
      isVat: true,
      isErrorProduct: false,
      monny_receive: 0,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      receive_item: {
        'ap_code': '',
        'tax_rate': 7,
        'bill_type': 0,
        'tax_type': 1,
        'bill_credit': 0,
        'doc_date': moment(new Date()),
        'due_date': moment(new Date()),
        'discount_word': '',
        'discount_amount': 0,
        'after_discount_amount': 0,
        'before_tax_amount': 0,
        'tax_amount': 0,
        'total_amount': 0,
        'cash_amount': 0,
        'change_amount': 0,
        'credit_card_amount': 0,
        'chq_amount': 0,
        'bank_amount': 0,
        'promt_pay_amount': 0,
        'bill_balance': 0,
        'is_pay_bill': 0,
        'sub': []
      },
      unit: [],
      catagory: [],
      code_receive: '',
      data_item: [],
      data_vender: [],
      item_detail: [],
      branch: [],
      ap_name: ""
    }
  },
  components: {
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.receive_item.sub.filter(items => {
        return (
          items.item_code.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    handleChangeItem (value, name) {
      // console.log(`selected ${value}`)
      // console.log(`selected ${name}`)
      this.isErrorProduct = false;
      this.modal_data.item_name = name
      this.getItem(value)
    },
    handleChange (value) {
      // console.log(`selected ${value}`)
    },
    handleChangeCus (value) {
      // console.log(`selected ${value}`)
      // console.log(this.$store.state.branchName )
      this.ap_name = value.name;
      // console.log(this.ap_name.includes('ต้นพยอม'))
      let start_date = moment(new Date())
      this.receive_item.due_date = start_date.add(value.datacredit_day, 'days')
      // console.log(JSON.stringify(this.receive_item.due_date))
    },
    handleBlur () {
      console.log('blur')
    },
    handleFocus () {
      console.log('focus')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    removeCus (index) {
      this.receive_item.sub.splice(index, 1)
      this.calPriceAll()
    },
    addSub () {
      if (this.modal_data.item_code !== '') {
        this.isErrorProduct = false;
        var index = this.receive_item.sub.findIndex(x => x.item_code === this.modal_data.item_code)
        if (index < 0) {
          this.receive_item.sub.unshift(this.modal_data)
        } else {
          this.receive_item.sub[index] = this.modal_data
        }
        this.modal_active = false
        this.calPriceAll()
      } else {
        this.isErrorProduct = true
      }
    },
    editItem (val) {
      // this.isVat = val.isVat
      this.modal_data = val
      this.modal_active = true
    },
    addItem () {
      let temp_data = {
        'item_code': '',
        'item_name': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'price': 0,
        'qty': 0,
        'avg_cost': 0,
        'lot_qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'discount_word': '',
        'discount_amount': 0,
        'amount': 0,
        'stock_type': 0,
        // 'rate1': 1,
        // 'rate2': 1,
        'is_cancel': 0,
        'line_number': 0,
        'isVat': 1
      }
      this.modal_data = temp_data
      // console.log(JSON.stringify(this.modal_data))
      this.modal_active = true
    },
    close_modal () {
      this.modal_active = false
    },
    itemCatagory () {
      api.itemCatagory(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.catagory = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหมวดหมู่ไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getUnit () {
      api.itemUnit(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        }, {},
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.unit = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
        }
      })
    },
    confirmPO () {
      if(this.receive_item.bill_status === 0 && this.receive_item.doc_status === 1) {
        this.$notification['warning']({
          message: 'ไม่สามารถอนุมัติโอนย้ายสาขาได้ เนื่องจากเคยมีการอนุมัติเอกสารเรียบร้อยแล้ว'
        })
      }else{
      // if(saveSuccess) {
        if (this.receive_item.ap_code == '' || this.receive_item.sub.length == 0) {
          this.$notification['warning']({
            message: 'กรุณากรอกข้อมูลให้ครบ'
          })
          return
        }
        console.log("doc_no", this.receive_item.doc_no)
        if (this.receive_item.doc_no) {
          this.updeteBill()
          // apiCenter.changeStock(
          //   {
          //     branchName : this.branch.branch_name.replaceAll(' ','') ,
          //     branchName2: this.ap_name.replaceAll(' ',''),
          //     receive_item: this.receive_item
          //   }  ,
          //   result => {
          //     if(result.data.success) {
          //       this.updeteBill()
          //     } else {
          //       this.$notification['warning']({
          //         message: 'กรณีเป็นเอกสารโอนย้าย จะต้องเลือกข้อมูลเจ้าหนี้ที่เป็นสาขาเท่านั้น'
          //       })
          //     }
          //   },
          //   error => {
          //     this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          //   }
          // );
        } else {
            this.addBill()
        }
      // } else {
      //   this.$notification['warning']({
      //     message: 'กรณีเป็นเอกสารโอนย้าย จะต้องเลือกข้อมูลเจ้าหนี้ที่เป็นสาขาเท่านั้น'
      //   })
      // }
     }
    },
    addBill () {
      for (let datas of this.receive_item.sub) {
        if (datas.isVat) {
          datas.isVat = 1
        } else {
          datas.isVat = 0
        }
      }
      this.receive_item.doc_date = moment(this.receive_item.doc_date).format('YYYY-MM-DD')
      this.receive_item.due_date = moment(this.receive_item.due_date).format('YYYY-MM-DD')
      console.log("access_token" , this.branch.access_token)
      api.createReceive(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        this.receive_item,
        result => {
          if (result.response === 'success') {
            this.$router.push('/receivelist')
            this.$notification['success']({
              message: 'บันทึกสำเร็จ',
              description: result.message
            })
          } else {
            this.$notification['warning']({
              message: 'ข้อมูลไม่ถูกต้อง',
              description: result.message
            })
          }
        },
        error => {
          alert('เกิดข้อผิดพลาด ' + JSON.stringify(error))
        }
      )
    },
    updeteBill () {
      // console.log(this.receive_item.sub.isVat)
      // if(this.receive_item.sub.isVat) {
      //   this.receive_item.sub.isVat = 1
      // } else {
      //   this.receive_item.sub.isVat = 0
      // }

      for (let datas of this.receive_item.sub) {
        if (datas.isVat) {
          datas.isVat = 1
        } else {
          datas.isVat = 0
        }
      }

      this.receive_item.doc_date = moment(this.receive_item.doc_date).format('YYYY-MM-DD')
      this.receive_item.due_date = moment(this.receive_item.due_date).format('YYYY-MM-DD')
      console.log("access_token" , this.branch.access_token)
      api.updateReceive(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        this.receive_item,
        result => {
          if (result.response === 'success') {
            this.$router.push('/receivelist')
            this.$notification['success']({
              message: 'บันทึกสำเร็จ',
              description: result.message
            })
          } else {
            this.$notification['warning']({
              message: 'ข้อมูลไม่ถูกต้อง',
              description: result.message
            })
          }
        },
        error => {
          alert('เกิดข้อผิดพลาด ' + JSON.stringify(error))
        }
      )
    },
    calPriceSub () {
      this.modal_data.lot_qty = this.modal_data.qty
      this.modal_data.amount = (this.modal_data.avg_cost * this.modal_data.qty) - this.modal_data.discount_amount
    },
    calPriceAll () {
      let SubAmount = 0
      // eslint-disable-next-line no-unused-vars
      let SubAmountNoTax = 0
      for (let index = 1; index <= this.receive_item.sub.length; index++) {
        // console.log(this.receive_item.sub[index - 1].isVat)
        if (this.receive_item.sub[index - 1].isVat)
        {
          SubAmount += this.receive_item.sub[index - 1].amount
        } else {
          SubAmountNoTax += this.receive_item.sub[index - 1].amount
        }
      }


      // this.receive_item.after_discount_amount = SubAmount - this.receive_item.discount_amount
      // console.log(this.receive_item.after_discount_amount)

      this.receive_item.after_discount_amount = SubAmountNoTax + SubAmount - this.receive_item.discount_amount

      this.receive_item.tax_amount = SubAmount * 0.07

      // let before_tax_subAmount = 0
      SubAmount  = SubAmount - (SubAmount * 0.07)

      this.receive_item.before_tax_amount = SubAmount + SubAmountNoTax
    },
    selectText (val) {
      document.getElementById(val).select()
    },
    callReceive () {
      if (this.code_receive == '0') {
        // console.log('New Receive')
        return
      }
      api.getReceive(
        this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {
          'doc_no': this.code_receive
        },
        result => {
          if (result.response === 'success') {
            this.receive_item = result.data
            if( this.data_vender.filter(data => data.code ===   this.receive_item.ap_code).length > 0)
            this.ap_name = this.data_vender.filter(data => data.code ===   this.receive_item.ap_code)[0].name;
            console.log(this.ap_name)
            this.receive_item.doc_date = moment(result.data.doc_date)
            this.receive_item.due_date = moment(result.data.due_date)
            if (this.receive_item.sub == null) {
              this.receive_item.sub = []
            }
            // setTimeout(() => {
            //   if (result.data.cash_amount != 0) {
            //     this.monny_receive = result.data.cash_amount
            //   } else if (result.data.credit_card_amount != 0) {
            //     this.monny_receive = result.data.credit_card_amount
            //   } else if (result.data.chq_amount != 0) {
            //     this.monny_receive = result.data.chq_amount
            //   } else if (result.data.bank_amount != 0) {
            //     this.monny_receive = result.data.bank_amount
            //   } else if (result.data.promt_pay_amount != 0) {
            //     this.monny_receive = result.data.promt_pay_amount
            //   }
            // }, 500)
            // console.log(this.receive_item)
          } else {
            this.$notification['error']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result
            })
          }
        },
        error => {
          // console.log(error)
          this.$notification['error']({
            message: 'ดึงข้อมูลไม่ได้',
            description: error.data.error
          })
          // alert('ไม่สามารถเข้าถึงข้อมูล ' + error)
        }
      )
    },
    addUnit (val) {
      let index = this.unit.find(x => x.id == val)
      // console.log(index)
      if (index == null) {
      } else {
        this.modal_data.unit_code = index.unit_code
      }
      // this.modal_data.unit_code = val
      // console.log(this.modal_data.unit_code)
    },
    getProductAll () {
      this.$store.state.isLoading = true
      api.listProduct(
        this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            // console.log(result)
            this.data_item = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getVenderAll () {
      this.$store.state.isLoading = true
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiV.listAll(
        this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === 'success') {
            this.data_vender = result.data
            if( this.data_vender.filter(data => data.code ===   this.receive_item.ap_code).length > 0)
              this.ap_name = this.data_vender.filter(data => data.code ===   this.receive_item.ap_code)[0].name;
            console.log(this.ap_name)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getItem (val) {
      this.$store.state.isLoading = true
      api.itemById(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        { 'id': parseInt(val) },
        result => {
          if (result.response === 'success') {
            // console.log(JSON.stringify(result))
            this.modal_data.price = result.data.bar_data[0].price_1
            this.modal_data.unit_id = result.data.stk_unit_id
            this.modal_data.unit_code = result.data.stk_unit_code
            this.modal_data.stock_type = result.data.stock_type
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    printBill () {
      this.$notification['warning']({
        message: 'แจ้งปัญหา',
        description: 'กำลังปรับปรุง'
      })
    }
  },
  created () {
    this.checkUser()
    this.getBranch()
    this.code_receive = this.$route.params.code
    setTimeout(() => {
      this.$store.state.branch_list.forEach(v => {
        if (parseInt(this.$route.params.branch_id) === parseInt(v['id'])) {
          this.branch = v
        }
      })
      setTimeout(() => {
        this.getUnit()
        this.itemCatagory()
        this.callReceive()
        this.getVenderAll()
      }, 1500)
    }, 1000)
  },
  mounted () {
    this.$store.state.isLoading = true
    setTimeout(() => {
      this.getProductAll()
      // console.log(this.branch)
      // console.log(this.$store.state.currentPath)
      // console.log(this.$store.state.historyPage)
    }, 2000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_storage.js